module.exports = __webpack_public_path__ + "img/goi.5e5a838a.png";